import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} HTMLElement - Play/pause button.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoPlayerComponent extends Component {
  requiredRefs = ['playButton', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { playButton } = this.refs;

    playButton?.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick() {
    const { playButton, videoElement } = this.refs;
    const isVideoPlaying = !!(videoElement.currentTime > 0 && !videoElement.paused && !videoElement.ended && videoElement.readyState > 2);
    console.log(isVideoPlaying)

    if (isVideoPlaying) {
      videoElement.pause()
      playButton.classList.add('paused')
      playButton.classList.remove('playing')
    } else {
      videoElement.play()
      playButton.classList.add('playing')
      playButton.classList.remove('paused')
    }
  }
}

if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayerComponent);
}
